import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import { addBreadcrumb } from "../store/ApplicationSlice"; // Adjust the import path as necessary

const MENU_ITEMS = [
  { route: "/app/details", label: "Intake Triage" },
  {
    route: (selectedAppId) => `/app/intake/${selectedAppId}`,
    label: "Application Overview",
  },
  { route: "/app/locations", label: "Company Analysis" },
  { route: "/app/escalate", label: "Referral" },
  { route: "/app/analytics", label: "Analytics" },
];

const MenuList = ({ isOpen, toggleMenu }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedAppId = useSelector(
    (state) => state.intakeData?.selectedAppId || ""
  );

  const [selectedRoute, setSelectedRoute] = useState(location.pathname);
  const menuRef = useRef(null);

  const handleMenuClick = (route, label) => {
    setSelectedRoute(route);
    if (location.pathname !== route) {
      dispatch(addBreadcrumb({ label, path: route }));
    }
    toggleMenu();
  };

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        toggleMenu(); // Close the menu
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleMenu]);

  return (
    <span>
      {/* Hamburger Icon */}
      <button
        className="text-gray-800 focus:outline-none flex top-4 left-4 z-20"
        onClick={toggleMenu}
      >
        <MenuIcon />
      </button>

      {/* Sidebar Menu */}
      <div
        ref={menuRef}
        className={`absolute top-0 left-0 bg-white border-r shadow-md transition-transform duration-300 z-20 left-nav ${
          isOpen ? "translate-x-0" : "-translate-x-full opacity-0"
        }`}
      >
        <ul className="mt-12">
          {MENU_ITEMS.map(({ route, label }, index) => {
            const resolvedRoute =
              typeof route === "function" ? route(selectedAppId) : route;
            const isActive = selectedRoute === resolvedRoute;

            return (
              <li
                key={index}
                className={`px-2 py-2 hover:bg-gray-200 cursor-pointer ${
                  isActive ? "light-orange font-semibold" : ""
                }`}
              >
                <Link
                  to={resolvedRoute}
                  onClick={() => handleMenuClick(resolvedRoute, label)}
                >
                  {label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </span>
  );
};

export default MenuList;
